<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="'/'">Home</a>
      </li>
      <li>
        <a [routerLink]="'/lager'"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
    </ul>
  </div>
</div>
<div class="page-content overflow-y-auto flex flex-col px-4 pb-2 items-center justify-center gap-2 text-center">
  <a routerLink="/lager/uebersicht" class="bm-card bm-card-sm bm-card-border border-base-300 bg-base-100 w-96">
    <div class="bm-card-body">
      <div class="bm-card-title">Standorte</div>
    </div>
  </a>

  <a routerLink="/lager/eingang" class="bm-card bm-card-sm bm-card-border border-base-300 bg-base-100 w-96">
    <div class="bm-card-body">
      <div class="bm-card-title">Erfassung Großlieferung</div>
    </div>
  </a>

  <a routerLink="/lager/verarbeitung" class="bm-card bm-card-sm bm-card-border border-base-300 bg-base-100 w-96">
    <div class="bm-card-body">
      <div class="bm-card-title">Großlieferung Weiterverarbeitung</div>
    </div>
  </a>
</div>
